import { http } from "../helpers/easyindustriaapi/config";

export default class PedidoController {
  /**
   * Salva uma NFe não autorizada
   * @param {Object} nfeData - Dados da NFe
   * @param {number} empresaId - ID da empresa
   * @returns {Promise<Object>} - Dados da NFe salva
   */
  static async salvarNfe(nfeData, empresaId) {
    const response = await http.post(
      `nfe/salvarnfe?empresa_id=${empresaId}`,
      nfeData
    );
    return response.data;
  }

  /**
   * Faz upload de arquivos XML
   * @param {FormData} formData - Dados dos arquivos
   * @param {number} empresaId - ID da empresa
   * @returns {Promise<Object>} - Resultado do upload
   */
  static async uploadArquivos(formData, empresaId) {
    const response = await http.post(
      `nfe/arquivo?empresa_id=${empresaId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  }

  /**
   * Busca arquivos XML de uma empresa
   * @param {number} empresaId - ID da empresa
   * @returns {Promise<Array>} - Lista de arquivos
   */
  static async getArquivos(empresaId) {
    const response = await http.post(
      `nfe/getarquivo?empresa_id=${empresaId}`
    );
    return response.data;
  }

  /**
   * Busca cidades de um estado
   * @param {number} paisId - ID do país
   * @param {number} estadoId - ID do estado
   * @returns {Promise<Array>} - Lista de cidades
   */
  static async getCidades(paisId, estadoId) {
    const response = await http.get(`pais/${paisId}/estado/${estadoId}/cidades`);
    return response.data;
  }

  /**
   * Busca pessoas de uma empresa
   * @param {number} empresaId - ID da empresa
   * @returns {Promise<Array>} - Lista de pessoas
   */
  static async getPessoas(empresaId) {
    try {
      const response = await http.get(`/pessoa?empresa_id=${empresaId}`);
      
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error("Erro ao carregar lista de pessoas");
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 404) {
          throw new Error("Destino URL não encontrado!");
        } else {
          throw new Error(error.response.data || "Erro ao carregar pessoas");
        }
      }
      throw error;
    }
  }

  /**
   * Busca pedidos (NFes) de uma empresa
   * @param {number} empresaId - ID da empresa
   * @returns {Promise<Array>} - Lista de pedidos/NFes
   */
  static async getPedidos(empresaId) {
    try {
      const response = await http.get(`/nfe/teste2?empresa_id=${empresaId}`);
      
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error("Erro ao carregar lista de pedidos");
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 404) {
          throw new Error("Destino URL não encontrado!");
        } else {
          throw new Error(error.response.data || "Erro ao carregar pedidos");
        }
      }
      throw error;
    }
  }

  /**
   * Busca todas as tabelas necessárias para a tela de pedidos
   * Retorna produtos, históricos, tipos de movimento, estoques, caixas, etc.
   * @param {number} empresaId - ID da empresa
   * @returns {Promise<Object>} - Objeto com todas as tabelas (produtos, historicos, tipo_movimento, estoques, etc.)
   */
  static async getTabelas(empresaId) {
    try {
      const response = await http.get(`/tables/pedidos?empresa_id=${empresaId}`);
      
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error("Erro ao carregar tabelas");
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 404) {
          throw new Error("Destino URL não encontrado!");
        } else if (error.response.status === 422) {
          throw new Error("Dados inválidos: " + (error.response.data?.messages || "empresa_id inválido"));
        } else if (error.response.status === 500) {
          throw new Error(error.response.data?.message || "Erro ao buscar tabelas");
        } else {
          throw new Error(error.response.data?.message || error.response.data || "Erro ao carregar tabelas");
        }
      }
      throw error;
    }
  }

  /**
   * Retornar lista do IBGE de estados
   * @returns {Promise<Array>} - Lista de estados
   */
  getEstadosIBGE() {
    const promisse = http.get("https://servicodados.ibge.gov.br/api/v1/localidades/estados");
    return promisse.then(response => {
      return response.data;
    });
  }
}
